import localStorageHelper from "@/localstorage/localstorage";
/*
 * @Author: Jhonsem
 * @Date: 2019-06-13 14:41:35
 * @Last Modified by: Jhonsem
 * @Last Modified time: 2019-06-27 17:57:45
 */
const SAVE_TO_LOCAL_ALL_KEY = "SUPER_PAY_AND_BACK_UP_SAVE";

export const TEMP_KEY: any = {
  TEMP_PAYMEN_CLOSE_TIMES: "TEMP_PAYMEN_CLOSE_TIMES",
  TEMP_IAP_CANCEL_TIMES: "TEMP_IAP_CANCEL_TIMES",
  TEMP_SWITCH_TO_IAP_TIMES: "TEMP_SWITCH_TO_IAP_TIMES",
  TEMP_DELIVER_TOAST_SHOW_TIMES: "TEMP_DELIVER_TOAST_SHOW_TIMES",

  TEMP_SUPER_PAY_DIALOG_OR_RETAIN_SHOW_TIMES:
    "TEMP_SUPER_PAY_DIALOG_OR_RETAIN_SHOW_TIMES", //用来记下互斥事件

  VIP_CENTER_SHOW_TIMES: "VIP_CENTER_SHOW_TIMES"
};

export const RECORD_KEY: any = {
  //支付落地页 superpay_back_up显示的时候的index和显示名:
  PAY_RESULT_SUPER_OR_BACK_RECOMMEND_SHOW_RECORD:
    "PAY_RESULT_SUPER_OR_BACK_RECOMMEND_SHOW_RECORD",
  //支付落地页关闭后 superpay_back_up显示的时候的index和显示名:
  PAY_RESULT_PAGE_CLOSE_SUPER_OR_BACK_DIALOG_SHOW_RECORD:
    "PAY_RESULT_PAGE_CLOSE_SUPER_OR_BACK_DIALOG_SHOW_RECORD",
  //记录vip 或者 back_up 或者 super pay的记录
  LAUNCH_PAGE_SUPER_OR_BACK_OR_VIP_SHOW_RECORD:
    "LAUNCH_PAGE_SUPER_OR_BACK_OR_VIP_SHOW_RECORD"
};

export const LOCAL_KEY: any = {
  LOCAL_PAY_RESULT_PAGE_TIMES: "LOCAL_PAY_RESULT_PAGE_TIMES",
  LOCAL_PAY_RESULT_PAGE_CLOSE_TIMES: "LOCAL_PAY_RESULT_PAGE_CLOSE_TIMES",
  LOCAL_DELIVER_TOAST_CLOSE_TIMES: "LOCAL_DELIVER_TOAST_CLOSE_TIMES",
  LOCAL_DELIVER_TOAST_SHOW_TIMES: "LOCAL_DELIVER_TOAST_SHOW_TIMES",
  LOCAL_LAUNCH_MODAL_TIMES: "LOCAL_LAUNCH_MODAL_TIMES",

  //superpay:
  SUPER_PAY_PAY_RESULT_CLOSE_SHOW_TIMES:
    "SUPER_PAY_PAY_RESULT_CLOSE_SHOW_TIMES", //close superpay
  SUPER_PAY_PAY_RESULT_PAGE_SHOW_TIMES: "SUPER_PAY_PAY_RESULT_PAGE_SHOW_TIMES", //page superpay

  //backup:
  BACK_UP_PAY_RESULT_CLOSE_SHOW_TIMES: "BACK_UP_PAY_RESULT_CLOSE_SHOW_TIMES", //close backup
  BACK_UP_PAY_RESULT_PAGE_SHOW_TIMES: "BACK_UP_PAY_RESULT_PAGE_SHOW_TIMES", //page backup

  //others:
  SUPER_PAY_PAY_LAUNCH_SHOW_TIMES: "SUPER_PAY_PAY_LAUNCH_SHOW_TIMES",
  BACK_UP_APP_LAUNCH_SHOW_TIMES: "BACK_UP_APP_LAUNCH_SHOW_TIMES",

  //install:
  SUPER_PAY_INSTALL_TMEP_KEY: "SUPER_PAY_INSTALL_TMEP_KEY",
  BACK_UP_INSTALL_TMEP_KEY: "BACK_UP_INSTALL_TMEP_KEY"
};

class SuperPayAndBackUpHelpers {
  public tempAllData: any;
  public localAllData: any;

  constructor() {
    //初始化local的数据：
    this.localAllData = {};
    for (const key of Object.keys(LOCAL_KEY)) {
      this.localAllData[LOCAL_KEY[key]] = 0;
    }
    for (const key of Object.keys(RECORD_KEY)) {
      this.localAllData[RECORD_KEY[key]] = [];
    }
    if (!localStorageHelper.has(SAVE_TO_LOCAL_ALL_KEY)) {
      //没有存local的总数据
      this.saveAllLocalData();
    } else {
      //有存local的总数据:
      const localData = this.getAllLocalData(); //先取出
      console.log("先取出localData：", localData);
      this.localAllData = this.mergeData(this.localAllData, localData);
      console.log("merge localAllData：", this.localAllData);
      this.saveAllLocalData(); //更新local
    }

    //初始化temp的数据:
    this.tempAllData = new Map();
    for (const key of Object.keys(TEMP_KEY)) {
      this.tempAllData.set(TEMP_KEY[key], 0);
    }
    console.log("初始化后tempAllData:", this.tempAllData);
  }

  public mergeData(val: any, oldVal: any) {
    console.log("mergeData:", {
      val,
      oldVal
    });
    return {
      ...val,
      ...oldVal
    };
  }

  public getAllLocalData() {
    return localStorageHelper.get(SAVE_TO_LOCAL_ALL_KEY);
  }

  public saveAllLocalData() {
    localStorageHelper.set(SAVE_TO_LOCAL_ALL_KEY, this.localAllData);
    console.log("saveAllLocalData:", this.localAllData);
  }

  public setLocalKeyTimes(key: string, data: any) {
    this.localAllData[key] = data;
    this.saveAllLocalData();
  }

  public addLocalKeyTimes(key: string): void {
    let times = this.getLocalKeyTimes(key);
    this.localAllData[key] = times += 1;
    this.saveAllLocalData();
  }

  public pushRecord(key: string, record: any): void {
    const records: any = this.getLocalKeyTimes(key);
    records.push(record);
    this.saveAllLocalData();
  }

  public getLocalKeyTimes(key: string): number {
    return this.localAllData[key];
  }

  public addTempKeyTimes(key: string): void {
    let times = this.getTempKeyTimes(key);
    this.tempAllData.set(key, (times += 1));
  }

  public getTempKeyTimes(key: string): number {
    return this.tempAllData.get(key);
  }
}

const SuperPayAndBackUpHelpersInstance = new SuperPayAndBackUpHelpers();

export default SuperPayAndBackUpHelpersInstance;
